import { ApiPost, ApiPut, ApiDelete, ApiGet } from './Common.ts'
import { GetOrderEntryConnectorUrl } from '../stores/SettingsStore.ts'
import { useStoreLogger } from '../logger'
import type {
  ICartBatchedRequests,
  ICartCreate,
  ICartCreateResponse,
  ICartItemCreate,
  ICartItemDelete,
  ICartCustomerAdd,
  ICartGuestAdd,
  ICartEventAdd,
  ICartEventDelete,
  ICartResponse,
  ICartItemUpdate,
  ICartShippingAddressCreate,
  ICartPaymentMethodGetListResponse,
  ICartPaymentTokenCreate,
  ICartPaymentTokenCreateResponse,
  ICartPaymentDelete,
  ICartSubmitResponse,
  ICartPayeeAdd,
  ICartShipToTypeCreate,
  ICartShippingMethodCreate,
  ICartFreeDollarCouponAdd,
  ICartActiveUpdate,
  ICartPartyLead,
  ICartTokenRequest,
  IAoeInvoiceRequest,
  IAoeInvoiceSubmitRequest,
  IAoeInvoiceVerifyIdentityRequest,
  IAoeInvoiceListResponse,
  ICartCouponCreate,
  ICartGetByCustomerRequest,
  ICrossBorderKitCartCreate,
  ICrossBorderKitCartCreateResponse
} from '../types/CartTypes.ts'

export async function CartCreate(
  cart: ICartCreate,
): Promise<ICartCreateResponse> {
  const url = await GetOrderEntryConnectorUrl('cartcreate')
  return ApiPost(url, cart)
}

export async function CartItemCreate(cartItemCreate: ICartItemCreate) {
  const logger = useStoreLogger()
  logger.debug('cartItemCreate', cartItemCreate)
  const url = await GetOrderEntryConnectorUrl('cartitemcreate')
  return ApiPost(url, cartItemCreate)
}

export async function CartItemDelete(cartItemDelete: ICartItemDelete) {
  const logger = useStoreLogger()
  logger.debug('cartItemDelete', cartItemDelete)
  const url = await GetOrderEntryConnectorUrl('cartitemdelete')
  return ApiPost(url, cartItemDelete)
}

export async function CartCustomerAdd(cartCustomerAdd: ICartCustomerAdd) {
  const logger = useStoreLogger()
  logger.debug('CartCustomerAdd', cartCustomerAdd)
  const url = await GetOrderEntryConnectorUrl('CartCustomerCreate')
  return ApiPost(url, cartCustomerAdd)
}

export async function CartGuestAdd(cartGuestAdd: ICartGuestAdd) {
  const logger = useStoreLogger()
  logger.debug('CartGuestAdd', cartGuestAdd)
  const url = await GetOrderEntryConnectorUrl('CartGuestCreate')
  return ApiPost(url, cartGuestAdd)
}

export async function CartEventAdd(cartEventAdd: ICartEventAdd) {
  const logger = useStoreLogger()
  logger.debug('CartEventAdd', cartEventAdd)
  const url = await GetOrderEntryConnectorUrl('CartEventCreate')
  return ApiPost(url, cartEventAdd)
}

export async function CartEventDelete(cartEventDelete: ICartEventDelete) {
  const logger = useStoreLogger()
  logger.debug('CartEventDelete', cartEventDelete)
  const url = await GetOrderEntryConnectorUrl('CartEventDelete')
  return ApiPost(url, cartEventDelete)
}

export async function CartPayeeAdd(cartPayeeAdd: ICartPayeeAdd) {
  const logger = useStoreLogger()
  logger.debug('CartPayeeAdd', cartPayeeAdd)
  const url = await GetOrderEntryConnectorUrl('CartPayeeCreate')
  return ApiPost(url, cartPayeeAdd)
}

export async function CartBatchedRequests(
  batchedRequests: ICartBatchedRequests,
) {
  const url = await GetOrderEntryConnectorUrl('CartBatchedRequests')
  return ApiPost(url, batchedRequests)
}

export async function CartItemUpdate(cartItemUpdate: ICartItemUpdate) {
  const url = await GetOrderEntryConnectorUrl('CartItemUpdate')

  return ApiPost(url, cartItemUpdate)
}

export async function CartGet(aoeCartIdToken: string): Promise<ICartResponse> {
  const url = await GetOrderEntryConnectorUrl('CartGet')
  return ApiPost(url, { aoeCartIdToken })
}

export async function CartPaymentMethodGetList(
  aoeCartIdToken: string,
): Promise<ICartPaymentMethodGetListResponse> {
  const url = await GetOrderEntryConnectorUrl('CartPaymentMethodGetList')
  return ApiPost(url, { aoeCartIdToken })
}

export async function CartPaymentTokenCreate(
  cartPaymentTokenCreate: ICartPaymentTokenCreate,
): Promise<ICartPaymentTokenCreateResponse> {
  const url = await GetOrderEntryConnectorUrl('CartPaymentTokenCreate')
  return ApiPost(url, cartPaymentTokenCreate)
}

export async function CartPaymentDelete(
  cartPaymentDelete: ICartPaymentDelete,
): Promise<ICartResponse> {
  const url = await GetOrderEntryConnectorUrl('CartPaymentDelete')
  return ApiPost(url, cartPaymentDelete)
}

export async function CartPaymentCreate(
  cartPaymentCreate: {
    aoeCartIdToken: string;
    systemKeyword: string;
    charge: number;
    attributes?: Record<string, string>;
  },
): Promise<ICartResponse> {
  const url = await GetOrderEntryConnectorUrl('CartPaymentCreate')
  return ApiPost(url, cartPaymentCreate)
}

export async function CartShippingAddressCreate(
  cartAddressCreate: ICartShippingAddressCreate,
) {
  const logger = useStoreLogger()
  logger.debug('cartAddressCreate', cartAddressCreate)
  const url = await GetOrderEntryConnectorUrl('CartShippingAddressCreate')
  return ApiPost(url, cartAddressCreate)
}

export async function CartBillingAddressCreate(
  cartAddressCreate: ICartShippingAddressCreate,
) {
  const logger = useStoreLogger()
  logger.debug('cartAddressCreate', cartAddressCreate)
  const url = await GetOrderEntryConnectorUrl('CartBillingAddressCreate')
  return ApiPost(url, cartAddressCreate)
}

export async function CartSubmit(
  aoeCartIdToken: string,
): Promise<ICartSubmitResponse> {
  const url = await GetOrderEntryConnectorUrl('CartSubmit')
  return ApiPost(url, { aoeCartIdToken })
}

export async function CartShipToTypeCreate(
  cartShipToTypeCreate: ICartShipToTypeCreate,
) {
  const logger = useStoreLogger()
  logger.debug('CartShipToTypeCreate', cartShipToTypeCreate)
  const url = await GetOrderEntryConnectorUrl('CartShipToTypeCreate')
  return ApiPost(url, cartShipToTypeCreate)
}

export async function CartShippingMethodCreate(
  cartShippingMethodCreate: ICartShippingMethodCreate,
) {
  const logger = useStoreLogger()
  logger.debug('CartShippingMethodCreate', cartShippingMethodCreate)
  const url = await GetOrderEntryConnectorUrl('CartShippingMethodCreate')
  return ApiPost(url, cartShippingMethodCreate)
}

export async function CartFreeDollarCouponAdd(
  cartFDCAdd: ICartFreeDollarCouponAdd,
) {
  const logger = useStoreLogger()
  logger.debug('CartFreeDollarCouponAdd', cartFDCAdd)
  const url = await GetOrderEntryConnectorUrl('CartFreeDollarCouponCreate')
  return ApiPost(url, cartFDCAdd)
}

export async function CartFreeDollarCouponRemove(
  cartFDCRemove: ICartFreeDollarCouponAdd,
) {
  const logger = useStoreLogger()
  logger.debug('CartFreeDollarCouponRemove', cartFDCRemove)
  const url = await GetOrderEntryConnectorUrl('CartFreeDollarCouponDelete')
  return ApiPost(url, cartFDCRemove)
}

export async function CartActiveUpdate(cartActiveUpdate: ICartActiveUpdate) {
  const logger = useStoreLogger()
  logger.debug('CartActiveUpdate', cartActiveUpdate)
  const url = await GetOrderEntryConnectorUrl('CartActiveUpdate')
  return ApiPut(url, cartActiveUpdate)
}

export async function CartConsultantLeadCreate(
  cartConsLeadCreate: ICartTokenRequest,
) {
  const logger = useStoreLogger()
  logger.debug('CartConsultantLeadCreate', cartConsLeadCreate)
  const url = await GetOrderEntryConnectorUrl('CartConsultantLeadCreate')
  return ApiPost(url, cartConsLeadCreate)
}

export async function CartConsultantLeadDelete(
  cartConsLeadDelete: ICartTokenRequest,
) {
  const logger = useStoreLogger()
  logger.debug('CartConsultantLeadDelete', cartConsLeadDelete)
  const url = await GetOrderEntryConnectorUrl('CartConsultantLeadDelete')
  return ApiDelete(url, cartConsLeadDelete)
}

export async function CartPartyLeadCreate(cartPartyLeadCreate: ICartPartyLead) {
  const logger = useStoreLogger()
  logger.debug('CartPartyLeadCreate', cartPartyLeadCreate)
  const url = await GetOrderEntryConnectorUrl('CartPartyLeadCreate')
  return ApiPost(url, cartPartyLeadCreate)
}

export async function CartPartyLeadDelete(cartPartyLeadDelete: ICartPartyLead) {
  const logger = useStoreLogger()
  logger.debug('CartPartyLeadDelete', cartPartyLeadDelete)
  const url = await GetOrderEntryConnectorUrl('CartPartyLeadDelete')
  return ApiDelete(url, cartPartyLeadDelete)
}

export async function CartInvoiceCreate(cartInvoiceCreate: ICartTokenRequest) {
  const logger = useStoreLogger()
  logger.debug('CartInvoiceCreate', cartInvoiceCreate)
  const url = await GetOrderEntryConnectorUrl('CartInvoiceCreate')
  return ApiPost(url, cartInvoiceCreate)
}

export async function InvoiceGet(invoiceGet: IAoeInvoiceRequest) {
  const logger = useStoreLogger()
  logger.debug('InvoiceGet', invoiceGet)
  const url = await GetOrderEntryConnectorUrl('InvoiceGet')
  return ApiGet(url, invoiceGet)
}

export async function CartInvoiceUpdate(invoiceUpdate: ICartTokenRequest) {
  const logger = useStoreLogger()
  logger.debug('InvoiceUpdate', invoiceUpdate)
  const url = await GetOrderEntryConnectorUrl('CartInvoiceUpdate')
  return ApiPut(url, invoiceUpdate)
}

export async function CartInvoiceCancel(invoiceCancel: ICartTokenRequest) {
  const logger = useStoreLogger()
  logger.debug('CartInvoiceCancel', invoiceCancel)
  const url = await GetOrderEntryConnectorUrl('CartInvoiceCancel')
  return ApiPut(url, invoiceCancel)
}

export async function CartInvoiceResend(invoiceResend: ICartTokenRequest) {
  const logger = useStoreLogger()
  logger.debug('CartInvoiceResend', invoiceResend)
  const url = await GetOrderEntryConnectorUrl('CartInvoiceResend')
  return ApiPut(url, invoiceResend)
}

export async function InvoiceGetList() : Promise<IAoeInvoiceListResponse> {
  const logger = useStoreLogger()
  logger.debug('InvoiceGetList')
  const url = await GetOrderEntryConnectorUrl('InvoiceGetList')
  return ApiGet(url)
}

export async function InvoiceSubmit(invoiceSubmit: IAoeInvoiceSubmitRequest) {
  const logger = useStoreLogger()
  logger.debug('InvoiceSubmit', invoiceSubmit)
  const url = await GetOrderEntryConnectorUrl('InvoiceSubmit')
  return ApiPost(url, invoiceSubmit)
}

export async function InvoiceExists(invoiceExists: IAoeInvoiceRequest) {
  const logger = useStoreLogger()
  logger.debug('InvoiceExists', invoiceExists)
  const url = await GetOrderEntryConnectorUrl('InvoiceExists')
  return ApiGet(url, invoiceExists)
}

export async function InvoiceVerifyIdentity(invoiceVerifyIdentity: IAoeInvoiceVerifyIdentityRequest) {
  const logger = useStoreLogger()
  logger.debug('InvoiceVerifyIdentity', invoiceVerifyIdentity)
  const url = await GetOrderEntryConnectorUrl('InvoiceVerifyIdentity')
  return ApiPost(url, invoiceVerifyIdentity)
}

export async function CartCouponCreate(cartCouponCreate: ICartCouponCreate) {
  const logger = useStoreLogger()
  logger.debug('cartCouponCreate', cartCouponCreate)
  const url = await GetOrderEntryConnectorUrl('CartCouponCreate')
  return ApiPost(url, cartCouponCreate)
}

export async function CartGetByCustomer(cartGetByCustomer: ICartGetByCustomerRequest) {
  const logger = useStoreLogger()
  logger.debug('CartByCustomerGet', cartGetByCustomer)
  const url = await GetOrderEntryConnectorUrl('CartByCustomerGet')
  return ApiGet(url, cartGetByCustomer)
}

export async function CrossBorderKitCartCreate(
  crossBorderKitCartCreate: ICrossBorderKitCartCreate,
): Promise<ICrossBorderKitCartCreateResponse> {
  const logger = useStoreLogger()
  logger.debug('CrossBorderKitCartCreate', crossBorderKitCartCreate)
  const url = await GetOrderEntryConnectorUrl('CrossBorderKitCartCreate')
  return ApiPost(url, crossBorderKitCartCreate)
}
